import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords }) => {

    useEffect(() => {
        const existingDesc = document.querySelector('meta[name="description"]');
        if (existingDesc) existingDesc.remove();

        const existingKeywords = document.querySelector('meta[name="keywords"]');
        if (existingKeywords) existingKeywords.remove();
    }, []);

    return (
        <Helmet>
            <title>{title || 'Jagruti Chemicals'}</title>
            <meta name="description" key="description" content={description || 'Leading industrial chemical supplier in India'} />
            <meta name="keywords" key="keywords" content={keywords || 'chemicals, industrial chemicals, India'} />
            <meta property="og:title" content={title || 'Jagruti Chemicals'} />
            <meta property="og:description" content={description || 'Leading industrial chemical supplier in India'} />
            <meta name="twitter:title" content={title || 'Jagruti Chemicals'} />
            <meta name="twitter:description" content={description || 'Leading industrial chemical supplier in India'} />
        </Helmet>
    );
};

export default SEO;
